'use strict';

var ContributingServicesGridAggregationFactory = function ContributingServicesGridAggregationFactory(DataAggregationFactory) {
  function ContributingServicesGridAggregation() {
    DataAggregationFactory.call(this, 'contributing-services-mode', 'contributing-services');
  }
  ContributingServicesGridAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  ContributingServicesGridAggregation.constructor = ContributingServicesGridAggregation;
  ContributingServicesGridAggregation.prototype.aggregate = function (data) {
    return data;
  };
  return ContributingServicesGridAggregation;
};
ContributingServicesGridAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = ContributingServicesGridAggregationFactory;